import React from "react";
import Button, { ButtonColorTypes } from "./Button";

type Props = {
  canAddNotes: boolean;
  onClick?: () => void;
};

function ViewReportLogsButton({ onClick, canAddNotes }: Props) {
  if (!canAddNotes) return <></>;
  return (
    <Button
      text="View Report Logs"
      colorType={ButtonColorTypes.cancel}
      onClick={onClick}
      className="w-full"
    />
  );
}

export default ViewReportLogsButton;
